/* Diabetic Tools: renders the calculator named in [data-sk-tool] (see sections/diabetic-tool.liquid).
   Sliders (with a typeable value box), tap-to-select options and live results. Everything runs in the browser;
   nothing is stored or sent anywhere. Educational estimates only. */
(function () {
  'use strict';

  /* ---------- helpers ---------- */
  function num(v) { var n = parseFloat(v); return isFinite(n) ? n : NaN; }
  function round(n, d) { var p = Math.pow(10, d || 0); return Math.round(n * p) / p; }
  function q(sel, root) { return root.querySelector(sel); }
  function note(kind, title, text) { return '<div class="tl-note tl-note--' + kind + '"><strong>' + title + '</strong>' + text + '</div>'; }
  function stat(label, value, unit) {
    return '<div class="tl-stat"><div class="tl-stat__label">' + label + '</div><div class="tl-stat__value">' + value + (unit ? '<span class="tl-stat__unit">' + unit + '</span>' : '') + '</div></div>';
  }
  function stats(arr) { return '<div class="tl-stats">' + arr.join('') + '</div>'; }
  function list(items) { return '<ul class="tl-list">' + items.map(function (i) { return '<li>' + i + '</li>'; }).join('') + '</ul>'; }
  function field(label, html, hint, id) {
    return '<div class="tl-field"' + (id ? ' id="' + id + '"' : '') + '><label>' + label + '</label>' + html + (hint ? '<small>' + hint + '</small>' : '') + '</div>';
  }
  var SEE_DOCTOR = 'Please share this with your doctor and follow their advice.';

  /* slider with a value box you can also type in */
  function rng(id, label, min, max, step, val, unit, hint) {
    return '<div class="tl-field tl-rng"><div class="tl-rng__top"><label for="' + id + '">' + label + '</label>' +
      '<span class="tl-rng__val"><input type="number" inputmode="decimal" id="' + id + '-n" aria-label="' + label + ' value" min="' + min + '" max="' + max + '" step="' + step + '" value="' + val + '"><b>' + unit + '</b></span></div>' +
      '<input type="range" id="' + id + '" min="' + min + '" max="' + max + '" step="' + step + '" value="' + val + '">' +
      '<div class="tl-rng__ends"><span id="' + id + '-lo">' + min + '</span><span id="' + id + '-hi">' + max + '</span></div>' +
      (hint ? '<small>' + hint + '</small>' : '') + '</div>';
  }
  function paint(r) {
    var p = (num(r.value) - num(r.min)) / (num(r.max) - num(r.min)) * 100;
    r.style.setProperty('--p', Math.max(0, Math.min(100, p)) + '%');
  }
  function bindRng(root, id, cb) {
    var r = q('#' + id, root), n = q('#' + id + '-n', root);
    paint(r);
    r.addEventListener('input', function () { n.value = r.value; paint(r); if (cb) cb(); });
    n.addEventListener('input', function () {
      var v = num(n.value);
      if (isFinite(v) && v >= num(r.min) && v <= num(r.max)) { r.value = v; paint(r); if (cb) cb(); }
    });
    n.addEventListener('change', function () {
      var v = num(n.value); if (!isFinite(v)) v = num(r.value);
      v = Math.min(num(r.max), Math.max(num(r.min), v)); n.value = v; r.value = v; paint(r); if (cb) cb();
    });
  }
  function setVal(root, id, v) { var r = q('#' + id, root); r.value = v; q('#' + id + '-n', root).value = r.value; paint(r); }
  function setRange(root, id, min, max, step, val) {
    var r = q('#' + id, root), n = q('#' + id + '-n', root);
    [r, n].forEach(function (e) { e.min = min; e.max = max; e.step = step; });
    q('#' + id + '-lo', root).textContent = min; q('#' + id + '-hi', root).textContent = max;
    setVal(root, id, val);
  }
  function rv(root, id) { return num(q('#' + id, root).value); }

  /* tap-to-select buttons: cls 'tl-seg' (row) or 'tl-ropts' (list) */
  function seg(id, opts, cur, cls) {
    return '<div class="' + (cls || 'tl-seg') + '" id="' + id + '" role="radiogroup">' + opts.map(function (o) {
      return '<button type="button" role="radio" data-v="' + o[0] + '" aria-checked="' + (o[0] === cur) + '">' + o[1] + '</button>';
    }).join('') + '</div>';
  }
  function bindSeg(root, id, cb) {
    var g = q('#' + id, root);
    g.addEventListener('click', function (e) {
      var b = e.target.closest('button[data-v]'); if (!b) return;
      [].forEach.call(g.children, function (c) { c.setAttribute('aria-checked', c === b ? 'true' : 'false'); });
      if (cb) cb();
    });
  }
  function sv(root, id) { var b = q('#' + id + ' [aria-checked="true"]', root); return b ? b.getAttribute('data-v') : ''; }

  var tools = {};

  /* ---------- 1. HbA1c <-> average glucose ---------- */
  tools.hba1c = function (root) {
    root.innerHTML = '<div class="tl-grid2">' +
      rng('a1c', 'HbA1c', 4, 15, 0.1, 7, '%', 'From your lab report') +
      rng('eag', 'Average glucose', 68, 384, 1, 154, 'mg/dL', 'Move either slider') +
      '</div><div class="tl-result" aria-live="polite"></div>';
    var out = q('.tl-result', root);
    function show(h) {
      var eag = round(28.7 * h - 46.7, 0), kind, title, text;
      if (h < 5.7) { kind = 'good'; title = 'Normal range'; text = 'An HbA1c under 5.7% is in the normal range.'; }
      else if (h < 6.5) { kind = 'warn'; title = 'Prediabetes range'; text = 'An HbA1c of 5.7% to 6.4% is the range doctors call prediabetes. Lifestyle changes help a lot here. ' + SEE_DOCTOR; }
      else { kind = 'alert'; title = 'Diabetes range'; text = 'An HbA1c of 6.5% or more is the range doctors use to diagnose diabetes. For people already diagnosed, many doctors aim for under 7%, but your own target is personal. ' + SEE_DOCTOR; }
      out.innerHTML = stats([
        stat('HbA1c', round(h, 1), '%'), stat('Average glucose', eag, 'mg/dL'),
        stat('Average glucose', round(eag / 18.016, 1), 'mmol/L'), stat('HbA1c (IFCC)', round((h - 2.15) * 10.929, 0), 'mmol/mol')
      ]) + note(kind, title, text);
    }
    bindRng(root, 'a1c', function () { var h = rv(root, 'a1c'); setVal(root, 'eag', round(28.7 * h - 46.7, 0)); show(h); });
    bindRng(root, 'eag', function () { var h = round((rv(root, 'eag') + 46.7) / 28.7, 1); setVal(root, 'a1c', h); show(h); });
    show(7);
  };

  /* ---------- 2. mg/dL <-> mmol/L ---------- */
  tools.sugarconv = function (root) {
    root.innerHTML = '<div class="tl-grid2">' +
      rng('mgdl', 'Blood sugar', 40, 400, 1, 100, 'mg/dL') +
      rng('mmol', 'Blood sugar', 2.2, 22.2, 0.1, 5.6, 'mmol/L') + '</div>' +
      field('When was this reading taken?', seg('when', [['fasting', 'Fasting'], ['after', '2 hours after a meal'], ['random', 'Any other time']], 'fasting')) +
      '<div class="tl-result" aria-live="polite"></div>';
    var out = q('.tl-result', root);
    function show() {
      var v = rv(root, 'mgdl'), w = sv(root, 'when'), kind, title, text;
      if (v < 70) {
        kind = 'alert'; title = 'Low blood sugar';
        text = 'Below 70 mg/dL (3.9 mmol/L) is low. If you feel shaky, sweaty, dizzy or confused, take fast-acting sugar as your doctor has advised and get help if you do not improve. Tell your doctor about repeated lows.';
      } else if (w === 'fasting') {
        if (v < 100) { kind = 'good'; title = 'Normal fasting range'; text = 'Fasting sugar under 100 mg/dL (5.6 mmol/L) is in the normal range.'; }
        else if (v < 126) { kind = 'warn'; title = 'Prediabetes range'; text = 'Fasting sugar of 100 to 125 mg/dL (5.6 to 6.9 mmol/L) is the range doctors call prediabetes. ' + SEE_DOCTOR; }
        else { kind = 'alert'; title = 'Diabetes range'; text = 'Fasting sugar of 126 mg/dL (7.0 mmol/L) or more, confirmed on testing, is the range doctors use to diagnose diabetes. ' + SEE_DOCTOR; }
      } else if (w === 'after') {
        if (v < 140) { kind = 'good'; title = 'Normal after-meal range'; text = 'Under 140 mg/dL (7.8 mmol/L) two hours after a meal is in the normal range.'; }
        else if (v < 200) { kind = 'warn'; title = 'Higher than normal'; text = '140 to 199 mg/dL (7.8 to 11.0 mmol/L) after a meal is the prediabetes range. For people with diabetes, doctors often aim for under 180 mg/dL. ' + SEE_DOCTOR; }
        else { kind = 'alert'; title = 'High'; text = '200 mg/dL (11.1 mmol/L) or more after a meal is high. ' + SEE_DOCTOR; }
      } else {
        if (v < 140) { kind = 'good'; title = 'Usually normal'; text = 'Under 140 mg/dL (7.8 mmol/L) is usually normal for a random reading.'; }
        else if (v < 200) { kind = 'warn'; title = 'Higher than usual'; text = 'A random reading of 140 to 199 mg/dL is higher than usual. Check again fasting. ' + SEE_DOCTOR; }
        else { kind = 'alert'; title = 'High'; text = '200 mg/dL (11.1 mmol/L) or more at any time is high, especially with thirst, frequent urination or tiredness. ' + SEE_DOCTOR; }
      }
      out.innerHTML = note(kind, title, text);
    }
    bindRng(root, 'mgdl', function () { setVal(root, 'mmol', round(rv(root, 'mgdl') / 18.016, 1)); show(); });
    bindRng(root, 'mmol', function () { setVal(root, 'mgdl', round(rv(root, 'mmol') * 18.016, 0)); show(); });
    bindSeg(root, 'when', show);
    show();
  };

  /* ---------- 3. Indian Diabetes Risk Score (MDRF) ---------- */
  tools.idrs = function (root) {
    root.innerHTML = '<p class="tl-count">For adults who have not been diagnosed with diabetes.</p>' +
      field('Sex', seg('sex', [['m', 'Male'], ['f', 'Female']], 'm')) +
      '<div class="tl-grid2">' +
      rng('age', 'Age', 20, 90, 1, 40, 'years') +
      rng('waist', 'Waist circumference', 50, 150, 1, 90, 'cm', 'Around the navel, standing, after breathing out') + '</div>' +
      field('Physical activity', seg('act', [
        ['0', 'Regular exercise and strenuous work or routine'],
        ['20', 'Regular exercise OR strenuous work'],
        ['30', 'No exercise, desk or light work']], '0', 'tl-ropts')) +
      field('Family history of diabetes', seg('fam', [['0', 'Neither parent'], ['10', 'One parent'], ['20', 'Both parents']], '0')) +
      '<div class="tl-result" aria-live="polite"></div>';
    var out = q('.tl-result', root);
    function calc() {
      var age = rv(root, 'age'), waist = rv(root, 'waist'), male = sv(root, 'sex') === 'm';
      var p = age < 35 ? 0 : age < 50 ? 20 : 30;
      p += male ? (waist < 90 ? 0 : waist < 100 ? 10 : 20) : (waist < 80 ? 0 : waist < 90 ? 10 : 20);
      p += num(sv(root, 'act')) + num(sv(root, 'fam'));
      var kind, title, text;
      if (p < 30) { kind = 'good'; title = 'Low risk'; text = 'Your score suggests a low chance of having or developing diabetes. Keep up healthy habits and get a routine check-up.'; }
      else if (p < 60) { kind = 'warn'; title = 'Moderate risk'; text = 'Your score suggests a moderate risk. Asking your doctor for a fasting sugar or HbA1c test is a good idea, and lifestyle changes can lower your risk.'; }
      else { kind = 'alert'; title = 'High risk'; text = 'Your score suggests a high risk. Please get a fasting sugar and HbA1c test soon and speak to your doctor.'; }
      out.innerHTML = stats([stat('Your score', p, '/ 100')]) +
        '<div class="tl-bar tl-bar--' + (kind === 'good' ? 'ok' : kind) + '"><span style="width:' + p + '%"></span></div>' +
        note(kind, title, text) +
        '<p class="tl-count">Based on the Madras Diabetes Research Foundation (MDRF) Indian Diabetes Risk Score: below 30 low, 30 to 50 moderate, 60 or more high. It is a screening aid, not a diagnosis.</p>' +
        '<strong>What helps</strong>' + list(['Walk briskly for 30 minutes on most days', 'Cut down refined carbs, sweets and sugary drinks', 'Work towards a waist under ' + (male ? '90' : '80') + ' cm', 'Sleep well and manage stress']);
    }
    bindRng(root, 'age', calc); bindRng(root, 'waist', calc);
    bindSeg(root, 'sex', calc); bindSeg(root, 'act', calc); bindSeg(root, 'fam', calc);
    calc();
  };

  /* ---------- 4. Waist ratios ---------- */
  tools.waist = function (root) {
    root.innerHTML = '<div class="tl-grid2">' +
      field('Measure in', seg('unit', [['cm', 'Centimetres'], ['in', 'Inches']], 'cm')) +
      field('Sex', seg('sex', [['m', 'Male'], ['f', 'Female']], 'm')) + '</div>' +
      rng('ht', 'Height', 120, 210, 1, 165, 'cm', '<span id="fth"></span>') +
      rng('wa', 'Waist', 50, 150, 1, 90, 'cm', 'Around the navel, standing, after breathing out') +
      field('Add hip measurement?', seg('usehip', [['0', 'No'], ['1', 'Yes']], '0')) +
      '<div id="hipbox" hidden>' + rng('hp', 'Hip', 60, 160, 1, 98, 'cm', 'Around the widest part of the hips') + '</div>' +
      '<div class="tl-result" aria-live="polite"></div>';
    var out = q('.tl-result', root), unit = 'cm';
    function units() {
      var u = sv(root, 'unit');
      if (u === unit) return;
      var k = u === 'in' ? 1 / 2.54 : 2.54;
      var h = rv(root, 'ht') * k, w = rv(root, 'wa') * k, hp = rv(root, 'hp') * k;
      if (u === 'in') {
        setRange(root, 'ht', 47, 83, 1, Math.round(h)); setRange(root, 'wa', 20, 60, 0.5, round(w * 2, 0) / 2); setRange(root, 'hp', 24, 63, 0.5, round(hp * 2, 0) / 2);
      } else {
        setRange(root, 'ht', 120, 210, 1, Math.round(h)); setRange(root, 'wa', 50, 150, 1, Math.round(w)); setRange(root, 'hp', 60, 160, 1, Math.round(hp));
      }
      root.querySelectorAll('.tl-rng__val b').forEach(function (b) { b.textContent = u; });
      unit = u;
    }
    function calc() {
      var k = unit === 'in' ? 2.54 : 1, male = sv(root, 'sex') === 'm';
      var h = rv(root, 'ht') * k, w = rv(root, 'wa') * k, useHip = sv(root, 'usehip') === '1', hip = rv(root, 'hp') * k;
      var cut = male ? 90 : 80, ratio = w / h, html = '', items = [], kind;
      var ti = Math.round(h / 2.54); q('#fth', root).textContent = 'About ' + Math.floor(ti / 12) + ' ft ' + (ti % 12) + ' in';
      items.push(stat('Waist', round(w, 0), 'cm'));
      items.push(stat('Waist-to-height', round(ratio, 2)));
      var whr = NaN;
      if (useHip) { whr = w / hip; items.push(stat('Waist-to-hip', round(whr, 2))); }
      html += stats(items);
      html += w >= cut
        ? note('warn', 'Waist above the Indian cut-off', 'A waist of ' + cut + ' cm or more for ' + (male ? 'men' : 'women') + ' is linked with higher risk of diabetes and heart disease in Indians.')
        : note('good', 'Waist within the Indian cut-off', 'Below ' + cut + ' cm for ' + (male ? 'men' : 'women') + ' is the healthier range.');
      kind = ratio < 0.5 ? 'good' : ratio < 0.6 ? 'warn' : 'alert';
      html += note(kind, ratio < 0.5 ? 'Waist-to-height: healthy' : ratio < 0.6 ? 'Waist-to-height: increased risk' : 'Waist-to-height: high risk',
        'A simple rule: keep your waist under half your height. For you that is under ' + (unit === 'in' ? round(h / 2 / 2.54, 0) + ' in' : round(h / 2, 0) + ' cm') + '.');
      if (isFinite(whr)) {
        var hi = male ? 0.90 : 0.85;
        html += whr > hi
          ? note('warn', 'Waist-to-hip: higher risk', 'WHO treats a ratio above ' + hi.toFixed(2) + ' for ' + (male ? 'men' : 'women') + ' as increased risk.')
          : note('good', 'Waist-to-hip: within range', 'Under ' + hi.toFixed(2) + ' for ' + (male ? 'men' : 'women') + ' is the lower-risk range.');
      }
      out.innerHTML = html;
    }
    bindRng(root, 'ht', calc); bindRng(root, 'wa', calc); bindRng(root, 'hp', calc);
    bindSeg(root, 'sex', calc);
    bindSeg(root, 'unit', function () { units(); calc(); });
    bindSeg(root, 'usehip', function () { q('#hipbox', root).hidden = sv(root, 'usehip') !== '1'; calc(); });
    calc();
  };

  /* ---------- 5. Calories and carbs ---------- */
  tools.calorie = function (root) {
    root.innerHTML = '<div class="tl-grid2">' + field('Sex', seg('sex', [['m', 'Male'], ['f', 'Female']], 'm')) +
      field('Height in', seg('hu', [['cm', 'cm'], ['in', 'Feet and inches']], 'cm')) + '</div>' +
      '<div class="tl-grid3">' +
      rng('age', 'Age', 18, 80, 1, 45, 'years') +
      rng('ht', 'Height', 140, 200, 1, 165, 'cm', '<span id="ft"></span>') +
      rng('wt', 'Weight', 35, 150, 1, 70, 'kg') + '</div>' +
      field('Activity level', seg('act', [['1.2', 'Mostly sitting, little exercise'], ['1.375', 'Light: walks or exercise 1 to 3 days a week'], ['1.55', 'Moderate: exercise 3 to 5 days a week'], ['1.725', 'Active: hard exercise most days']], '1.2', 'tl-ropts')) +
      field('Your goal', seg('goal', [['-400', 'Lose weight slowly'], ['0', 'Stay at my weight'], ['300', 'Gain weight gently']], '0')) +
      '<div class="tl-result" aria-live="polite"></div>';
    var out = q('.tl-result', root);
    function calc() {
      var male = sv(root, 'sex') === 'm', age = rv(root, 'age'), h = rv(root, 'ht'), w = rv(root, 'wt');
      var inch = sv(root, 'hu') === 'in';
      if (inch) { q('#ft', root).textContent = Math.floor(h / 12) + ' ft ' + (h % 12) + ' in (about ' + Math.round(h * 2.54) + ' cm)'; h = h * 2.54; }
      else { var ti = Math.round(h / 2.54); q('#ft', root).textContent = 'About ' + Math.floor(ti / 12) + ' ft ' + (ti % 12) + ' in'; }
      var bmr = 10 * w + 6.25 * h - 5 * age + (male ? 5 : -161);
      var cal = bmr * num(sv(root, 'act')) + num(sv(root, 'goal'));
      var floor = male ? 1500 : 1200, floored = cal < floor;
      if (floored) cal = floor;
      cal = round(cal / 10, 0) * 10;
      var cLo = round(cal * 0.40 / 4, 0), cHi = round(cal * 0.50 / 4, 0);
      out.innerHTML = stats([
        stat('Calories a day', cal.toLocaleString('en-IN'), 'kcal'),
        stat('Carbs a day', cLo + ' to ' + cHi, 'g'),
        stat('Each main meal', round(cLo * 0.25, 0) + ' to ' + round(cHi * 0.25, 0), 'g carbs'),
        stat('Each snack', round(cLo * 0.125, 0) + ' to ' + round(cHi * 0.125, 0), 'g carbs')
      ]) +
        (floored ? note('warn', 'Minimum shown', 'Very low calorie targets are not safe without medical supervision, so we show a minimum of ' + floor + ' kcal.') : '') +
        note('info', 'How this is worked out', 'Calories use the Mifflin-St Jeor formula for your resting needs, multiplied by your activity level. Carbs are set at 40% to 50% of calories, a common range for people managing blood sugar. Meals assume 3 main meals (25% each) and 2 snacks (12.5% each). Choose whole grains, millets, pulses and vegetables over refined carbs.') +
        note('warn', 'Your doctor may set a different target', 'People on insulin or sugar-lowering medicines, or with kidney or heart conditions, may need a different plan. ' + SEE_DOCTOR);
    }
    ['age', 'ht', 'wt'].forEach(function (id) { bindRng(root, id, calc); });
    ['sex', 'act', 'goal'].forEach(function (id) { bindSeg(root, id, calc); });
    var hunit = 'cm';
    bindSeg(root, 'hu', function () {
      var u = sv(root, 'hu'); if (u === hunit) return;
      var cur = rv(root, 'ht');
      if (u === 'in') setRange(root, 'ht', 55, 79, 1, Math.round(cur / 2.54)); else setRange(root, 'ht', 140, 200, 1, Math.round(cur * 2.54));
      var b = q('#ht', root).closest('.tl-rng').querySelector('.tl-rng__val b'); b.textContent = u === 'in' ? 'in' : 'cm';
      hunit = u; calc();
    });
    calc();
  };

  /* ---------- Food data (6 and 7). GI values are approximate; they vary with variety, cooking and what is eaten with the food. ---------- */
  var CATS = window.SK_FOOD.cats, FOODS = window.SK_FOOD.foods;
  function gl(f) { return f[2] == null ? 0 : round(f[2] * f[4] / 100, 0); }
  function giClass(g) { return g <= 55 ? 'lo' : g < 70 ? 'med' : 'hi'; }
  function glClass(g) { return g <= 10 ? 'lo' : g < 20 ? 'med' : 'hi'; }
  var CLS_TEXT = { lo: 'Low', med: 'Medium', hi: 'High' };

  /* ---------- 6. Glycemic index lookup ---------- */
  tools.gi = function (root) {
    var cat = -1;
    root.innerHTML = '<div class="tl-field"><label for="s">Search a food</label><input type="search" id="s" placeholder="e.g. rice, roti, mango"></div>' +
      '<div class="tl-chips" id="chips"></div>' +
      field('Sort by', seg('sort', [['az', 'A to Z'], ['gi', 'Lowest GI first'], ['gl', 'Lowest GL first']], 'az')) +
      '<div class="tl-count" id="cnt"></div><div class="tl-foods" id="list"></div>' +
      '<div class="tl-note tl-note--info" style="margin-top:16px"><strong>How to read this</strong>Glycemic index (GI) shows how fast a food raises blood sugar: low 55 or less, medium 56 to 69, high 70 or more. Glycemic load (GL) also counts the portion: low 10 or less, medium 11 to 19, high 20 or more. Values are approximate and change with variety, cooking and what you eat the food with. Pairing carbs with vegetables, dal or curd slows the rise.</div>';
    var chips = q('#chips', root), list = q('#list', root), cnt = q('#cnt', root), s = q('#s', root);
    function drawChips() {
      chips.innerHTML = ['All'].concat(CATS).map(function (c, i) {
        return '<button type="button" class="tl-chip" data-c="' + (i - 1) + '" aria-pressed="' + (cat === i - 1) + '">' + c + '</button>';
      }).join('');
    }
    function draw() {
      var t = s.value.trim().toLowerCase(), sort = sv(root, 'sort');
      var rows = FOODS.filter(function (f) { return (cat < 0 || f[1] === cat) && (!t || f[0].toLowerCase().indexOf(t) > -1); });
      rows.sort(function (a, b) { return sort === 'gi' ? (a[2] == null ? -1 : a[2]) - (b[2] == null ? -1 : b[2]) : sort === 'gl' ? gl(a) - gl(b) : a[0].localeCompare(b[0]); });
      cnt.textContent = rows.length + (rows.length === 1 ? ' food' : ' foods');
      list.innerHTML = rows.map(function (f) {
        var g = gl(f), a = giClass(f[2] == null ? 0 : f[2]), b = glClass(g);
        if (f[2] == null) return '<div class="tl-food"><div class="tl-food__name">' + f[0] + '</div><div class="tl-food__meta">' + f[3] + ' &middot; ' + f[4] + ' g carbs</div><div class="tl-badges"><span class="tl-badge tl-badge--lo">Almost no carbs &middot; no GI</span></div></div>';
        return '<div class="tl-food"><div class="tl-food__name">' + f[0] + '</div><div class="tl-food__meta">' + f[3] + ' &middot; ' + f[4] + ' g carbs</div>' +
          '<div class="tl-badges"><span class="tl-badge tl-badge--' + a + '">GI ' + f[2] + ' &middot; ' + CLS_TEXT[a] + '</span><span class="tl-badge tl-badge--' + b + '">GL ' + g + ' &middot; ' + CLS_TEXT[b] + '</span></div></div>';
      }).join('') || '<p>No food found. Try another word.</p>';
    }
    chips.addEventListener('click', function (e) {
      var b = e.target.closest('.tl-chip'); if (!b) return;
      cat = parseInt(b.getAttribute('data-c'), 10); drawChips(); draw();
    });
    s.addEventListener('input', draw);
    bindSeg(root, 'sort', draw);
    drawChips(); draw();
  };

  /* ---------- 7. Carb counter / plate builder ---------- */
  tools.plate = function (root) {
    var plate = [];
    root.innerHTML = rng('target', 'Carb target for this meal', 20, 120, 5, 45, 'g', 'A common starting point is 45 g. Use your doctor or dietitian\'s number if you have one, or the Calorie and carb target tool.') +
      SKCombo.html('food', 'Add a food', 'Search or pick a food, e.g. roti, dal, idli') +
      field('Servings', seg('qty', [['0.5', '&frac12;'], ['1', '1'], ['1.5', '1&frac12;'], ['2', '2'], ['3', '3']], '1')) +
      '<button type="button" class="btn-sk-primary tl-btn" id="add">Add to my meal</button>' +
      '<ul class="tl-plate" id="plate"></ul><div class="tl-result" aria-live="polite"></div>';
    var ul = q('#plate', root), out = q('.tl-result', root);
    function draw() {
      ul.innerHTML = plate.map(function (p, i) {
        var f = FOODS[p.i];
        return '<li><span>' + f[0] + ' &times; ' + p.n + '</span><span>' + round(f[4] * p.n, 0) + ' g</span><button type="button" data-r="' + i + '" aria-label="Remove ' + f[0] + '">&times;</button></li>';
      }).join('');
      if (!plate.length) { out.innerHTML = note('info', 'Your meal is empty', 'Pick a food and tap Add to my meal. Add everything on your plate to see the total carbs.'); return; }
      var carbs = 0, load = 0, high = [];
      plate.forEach(function (p) {
        var f = FOODS[p.i]; carbs += f[4] * p.n; load += gl(f) * p.n;
        if (f[2] >= 70 && high.indexOf(f[0]) < 0) high.push(f[0]);
      });
      carbs = round(carbs, 0); load = round(load, 0);
      var t = rv(root, 'target'), pct = carbs / t * 100, kind, msg;
      if (pct <= 100) { kind = 'good'; msg = 'Within your target of ' + t + ' g.'; }
      else if (pct <= 125) { kind = 'warn'; msg = 'A little over your target of ' + t + ' g. Try a smaller portion of the highest-carb item.'; }
      else { kind = 'alert'; msg = 'Well over your target of ' + t + ' g. Cut a portion or swap an item.'; }
      out.innerHTML = stats([stat('Total carbs', carbs, 'g'), stat('Estimated glycemic load', load)]) +
        '<div class="tl-bar tl-bar--' + (kind === 'good' ? 'ok' : kind) + '"><span style="width:' + Math.min(100, round(pct, 0)) + '%"></span></div>' + note(kind, carbs + ' g of ' + t + ' g', msg) +
        (high.length ? note('info', 'Higher-GI items on your plate', high.join(', ') + '. Try a smaller portion, or swap for a lower-GI choice such as brown rice, millet roti, dal or chana, and add vegetables or curd to slow the rise.') : '');
    }
    bindRng(root, 'target', draw);
    bindSeg(root, 'qty', null);
    SKCombo.init(root, 'food', FOODS.map(function (f, i) { return { label: f[0] + ' (' + f[3] + ')', group: CATS[f[1]], cat: f[1], v: i }; })
      .sort(function (a, b) { return a.cat - b.cat || a.v - b.v; }), 0);
    q('#add', root).addEventListener('click', function () {
      plate.push({ i: parseInt(q('#food', root).value, 10), n: num(sv(root, 'qty')) }); draw();
    });
    ul.addEventListener('click', function (e) {
      var b = e.target.closest('button[data-r]'); if (!b) return;
      plate.splice(parseInt(b.getAttribute('data-r'), 10), 1); draw();
    });
    draw();
  };

  /* ---------- 10. Sugar control quiz ---------- */
  var QUIZ = [
    ['What was your last HbA1c?', ['Below 7%', '7% to 8%', 'Above 8%', 'I do not know'], [0, 1, 2, 1]],
    ['Your usual fasting sugar?', ['80 to 130 mg/dL', '131 to 180 mg/dL', 'Above 180 mg/dL, or sometimes below 70', 'I do not check'], [0, 1, 2, 1]],
    ['Your sugar 2 hours after meals?', ['Below 180 mg/dL', '180 to 250 mg/dL', 'Above 250 mg/dL', 'I do not check'], [0, 1, 2, 1]],
    ['In the last month, how often did you have extra thirst, frequent urination, tiredness or blurred vision?', ['Rarely or never', 'Sometimes', 'Often'], [0, 1, 2]],
    ['Do you take your medicines or supplements as advised?', ['Always', 'Most of the time', 'I often miss them'], [0, 1, 2]],
    ['How is your food?', ['Balanced, with controlled portions', 'Sometimes sweets or refined foods', 'Often sugary, refined or fried'], [0, 1, 2]],
    ['How active are you?', ['30 minutes or more on most days', 'A few days a week', 'Rarely'], [0, 1, 2]],
    ['Sleep and stress?', ['Sleep well, stress is manageable', 'Some trouble', 'Poor sleep or high stress most days'], [0, 1, 2]]
  ];
  /* Step form: one question per screen, auto-advances on choice, Back to change an answer, result at the end. */
  tools.quiz = function (root) {
    var n = QUIZ.length, step = 0, ans = [];
    function bar(done, label) {
      return '<div class="tl-progress"><div class="tl-bar"><span style="width:' + round(done / n * 100, 0) + '%"></span></div><span>' + label + '</span></div>';
    }
    function ask() {
      var qq = QUIZ[step];
      root.innerHTML = bar(step, 'Question ' + (step + 1) + ' of ' + n) +
        '<fieldset class="tl-q tl-step"><legend>' + qq[0] + '</legend>' +
        '<div class="tl-ropts" id="opts" role="radiogroup">' + qq[1].map(function (o, oi) {
          return '<button type="button" role="radio" data-i="' + oi + '" aria-checked="' + (ans[step] === oi) + '">' + o + '</button>';
        }).join('') + '</div></fieldset>' +
        '<div class="tl-nav">' + (step > 0 ? '<button type="button" class="tl-btn--ghost" id="back">&larr; Back</button>' : '<span></span>') +
        (ans[step] !== undefined ? '<button type="button" class="btn-sk-primary tl-btn" id="next">' + (step === n - 1 ? 'See my result' : 'Next') + '</button>' : '') + '</div>';
      q('#opts', root).addEventListener('click', function (e) {
        var b = e.target.closest('button[data-i]'); if (!b) return;
        ans[step] = parseInt(b.getAttribute('data-i'), 10);
        [].forEach.call(this.children, function (c) { c.setAttribute('aria-checked', c === b ? 'true' : 'false'); });
        setTimeout(go, 280);
      });
      var back = q('#back', root), next = q('#next', root);
      if (back) back.addEventListener('click', function () { step--; ask(); });
      if (next) next.addEventListener('click', go);
    }
    function go() {
      if (ans[step] === undefined) return;
      if (step < n - 1) { step++; ask(); } else { result(); }
      root.scrollIntoView({ behavior: 'smooth', block: 'nearest' });
    }
    function result() {
      var total = 0;
      QUIZ.forEach(function (qq, i) { total += qq[2][ans[i]]; });
      var kind, title, text, tips;
      if (total <= 4) { kind = 'good'; title = 'Looks on track'; text = 'Your answers suggest your sugar is reasonably well managed. Keep going and keep your regular check-ups.'; tips = ['Test HbA1c every 3 months, or as your doctor advises', 'Keep up your food, activity and sleep routine']; }
      else if (total <= 9) { kind = 'warn'; title = 'Needs attention'; text = 'Some answers suggest your sugar may not be as well controlled as it could be. Small changes can help, and a chat with your doctor or our team is worthwhile.'; tips = ['Check fasting and after-meal sugar more regularly and note the numbers', 'Walk for 10 minutes after meals', 'Reduce refined carbs, sweets and fried food', 'Take medicines exactly as advised']; }
      else { kind = 'alert'; title = 'Please speak to your doctor soon'; text = 'Your answers suggest your sugar may be running high or that symptoms need a look. Please see your doctor soon and share these answers.'; tips = ['Book a check-up with your doctor and ask for an HbA1c test', 'Do not stop or change your medicines on your own', 'Get urgent medical help if you feel very unwell, are vomiting, confused, breathless or very drowsy']; }
      root.innerHTML = bar(n, 'Done') + '<div class="tl-result" aria-live="polite">' +
        stats([stat('Your score', total, '/ 16 (lower is better)')]) + note(kind, title, text) + '<strong>Next steps</strong>' + list(tips) +
        '<p class="tl-count">This quiz is a conversation starter, not a diagnosis.</p></div>' +
        '<div class="tl-nav"><button type="button" class="tl-btn--ghost" id="back">&larr; Change an answer</button><button type="button" class="tl-btn--ghost" id="again">Start again</button></div>';
      q('#back', root).addEventListener('click', function () { step = n - 1; ask(); });
      q('#again', root).addEventListener('click', function () { step = 0; ans = []; ask(); });
    }
    ask();
  };

  /* ---------- 11. Water and step goal ---------- */
  tools.waterstep = function (root) {
    root.innerHTML = '<div class="tl-grid2">' +
      rng('wt', 'Weight', 30, 150, 1, 70, 'kg') +
      rng('age', 'Age', 18, 85, 1, 45, 'years') + '</div>' +
      rng('steps', 'Your average steps a day now', 0, 15000, 500, 4000, 'steps', 'Check a phone or watch step counter. Leave at 0 if you do not know.') +
      field('Activity level', seg('act', [['30', 'Low: mostly sitting'], ['33', 'Moderate: some exercise'], ['36', 'High: exercise most days']], '30')) +
      field('Weather where you live', seg('hot', [['0', 'Mild'], ['500', 'Hot or humid']], '0')) +
      '<div class="tl-result" aria-live="polite"></div>';
    var out = q('.tl-result', root);
    function calc() {
      var w = rv(root, 'wt'), age = rv(root, 'age'), cur = rv(root, 'steps');
      var ml = w * num(sv(root, 'act')) + num(sv(root, 'hot'));
      ml = Math.min(4000, Math.max(1500, ml));
      var litres = round(ml / 1000, 1), glasses = round(ml / 250, 0);
      var cap = age >= 60 ? 7000 : 10000, goal = Math.min(cap, Math.max(cur + 2000, 4000));
      goal = Math.round(goal / 500) * 500;
      var already = cur >= cap;
      if (already) goal = cur;
      var weeks = [], s = cur === 0 ? 2000 : cur;
      while (s < goal && weeks.length < 8) { s = Math.min(goal, s + 1000); weeks.push(s); }
      out.innerHTML = stats([
        stat('Water a day', litres, 'litres'), stat('That is about', glasses, 'glasses of 250 ml'),
        stat('Step goal', goal.toLocaleString('en-IN'), 'steps a day'), stat('Roughly', Math.round(goal / 100), 'minutes of walking')
      ]) +
        (already ? note('good', 'You are already there', 'You walk more than the usual goal for your age. Keep it up, and keep a steady routine rather than adding more.') : '') +
        (weeks.length ? '<strong>A gentle build-up</strong>' + list(weeks.map(function (v, i) { return 'Week ' + (i + 1) + ': ' + v.toLocaleString('en-IN') + ' steps a day'; })) : '') +
        note('info', 'Tips', 'A 10 minute walk after each meal helps lower the sugar rise after eating. Sip water through the day instead of drinking a lot at once, and choose water over sugary drinks.') +
        note('warn', 'Check with your doctor first if', 'you have kidney, heart or liver problems (your doctor may limit fluids), foot ulcers or neuropathy, or you take insulin or sugar-lowering medicines. Build up slowly and stop if you feel dizzy or unwell.');
    }
    ['wt', 'age', 'steps'].forEach(function (id) { bindRng(root, id, calc); });
    ['act', 'hot'].forEach(function (id) { bindSeg(root, id, calc); });
    calc();
  };

  /* step form for the multi-field tools: one question (or pair) at a time with a progress bar and Back / Next.
     The tools keep calculating live; the result simply stays hidden until the last step. */
  function wizard(root) {
    var out = q('.tl-result', root), keep = ['tl-count', 'tl-result'], steps = [];
    [].slice.call(root.children).forEach(function (k) {
      if (keep.some(function (c) { return k.classList.contains(c); })) return;
      if (k.hidden && steps.length) { steps[steps.length - 1].appendChild(k); return; } // a conditional box belongs to the question above it
      if (k.classList.contains('tl-grid2') || k.classList.contains('tl-grid3')) {
        var items = [].slice.call(k.children);
        if (items.length > 2) {
          for (var i = 0; i < items.length; i += 2) {
            var g = document.createElement('div'); g.className = 'tl-grid2'; g.appendChild(items[i]); if (items[i + 1]) g.appendChild(items[i + 1]);
            root.insertBefore(g, k); steps.push(g);
          }
          root.removeChild(k); return;
        }
      }
      var s = document.createElement('div'); root.insertBefore(s, k); s.appendChild(k); steps.push(s);
    });
    if (steps.length < 2 || !out) return;
    var prog = document.createElement('div'); prog.className = 'tl-progress';
    prog.innerHTML = '<div class="tl-bar"><span></span></div><span class="tl-step-txt" aria-live="polite"></span>';
    root.insertBefore(prog, steps[0]);
    var nav = document.createElement('div'); nav.className = 'tl-nav tl-stepnav';
    nav.innerHTML = '<button type="button" class="tl-btn--ghost" data-back>&larr; Back</button><button type="button" class="btn-sk-primary tl-btn" data-next>Next</button>';
    root.insertBefore(nav, out);
    var cur = 0, last = steps.length - 1, back = q('[data-back]', nav), next = q('[data-next]', nav);
    steps.forEach(function (s) { s.className += ' tl-step'; });
    function show(i) {
      cur = Math.max(0, Math.min(last, i));
      steps.forEach(function (s, n) { s.hidden = n !== cur; });
      q('.tl-bar span', prog).style.width = round((cur + 1) / steps.length * 100, 0) + '%';
      q('.tl-step-txt', prog).textContent = cur === last ? 'Your result' : 'Question ' + (cur + 1) + ' of ' + steps.length;
      back.style.visibility = cur === 0 ? 'hidden' : 'visible'; next.hidden = cur === last;
      out.classList.toggle('tl-result--wait', cur !== last);
    }
    back.addEventListener('click', function () { show(cur - 1); });
    next.addEventListener('click', function () { show(cur + 1); });
    show(0);
  }
  var WIZARD = { idrs: 1, waist: 1, calorie: 1, waterstep: 1 };

  var root = document.querySelector('[data-sk-tool]');
  if (root && tools[root.getAttribute('data-sk-tool')]) {
    tools[root.getAttribute('data-sk-tool')](root);
    if (WIZARD[root.getAttribute('data-sk-tool')]) wizard(root);
  }
})();
